//
//
//
//
//
//
//
//

import sectionIndex from '~/components/section/index/section'
import TopFlotilla from '~/components/section/banners/topFlotilla'

export default {
  name: 'HomeBannersSlider',
  components: {
    sectionIndex,
    TopFlotilla
  },
  props: {
    slider: {
      type: Object,
      default: () => {}
    },
    container: {
      type: Boolean,
      default: true
    }
  }
}
